import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { UserAvatar } from '@bonusly/common-user-popover';
import { Button, CalendarOutline, Flex, RefreshOutline, rem, Text } from '@bonusly/design-system';
import { EventEntity } from '@bonusly/one-on-ones-entities';
import { UserDetailEntity } from '@bonusly/user-entities';

export interface GuestAvatarProps {
	guest: UserDetailEntity;
	event?: EventEntity;
}

export const GuestAvatar: FC<GuestAvatarProps> = ({ event, guest }) => {
	const { t } = useTranslation('one_on_ones');

	return (
		<Flex bgColor="bg.canvas" borderRadius={8} p={4} minH={rem(80)} alignItems="center" gap={3} w="full">
			<Flex w={rem(48)}>
				<UserAvatar size="lg" userId={guest.id} borderColor="text.onColor" borderWidth={1} />
			</Flex>

			<Flex justifyContent="space-between" w="full" alignItems="center">
				<Flex flexDir="column" gap={0}>
					<Text size="lg" variant="strong">
						{guest.displayName}
					</Text>
					<Text size="sm" color="text.softest">{`@${guest.username}`}</Text>

					{event && (
						<Flex alignItems="center" gap={2}>
							<Button colorScheme="secondary" variant="alpha" size="xs" disabled>
								<Flex gap={1} justifyContent="space-between" alignItems="center">
									<CalendarOutline size="xs" />
									{t(`schedule_day_of_week_options.${event.scheduleDayOfWeek}`)}
								</Flex>
							</Button>
							<Button colorScheme="secondary" variant="alpha" size="xs" disabled>
								<Flex gap={1} justifyContent="space-between" alignItems="center">
									<RefreshOutline size="xs" />
									{t(`meeting.modal.form.cadence.recurrence_options.${event.frequency}`)}
								</Flex>
							</Button>
						</Flex>
					)}
				</Flex>
			</Flex>
		</Flex>
	);
};
